// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{display:inline-block;position:relative;font-size:0;overflow:hidden}:host canvas{width:inherit;height:inherit;max-height:inherit;max-width:inherit}:host img{display:inline-block;width:100%;height:auto;position:absolute;top:0;left:0}", ""]);
// Exports
module.exports = exports;
